export const getCompaniesSelector = (state) => state.companies.items
export const getCompaniesCurrentPageSelector = (state) => state.companies.current_page
export const getCompaniesPageCountSelector = (state) => state.companies.page_count

// Keep old selectors for backward compatibility
export const getDivisionsSelector = (state) => state.companies.items
export const getDivisionsCurrentPageSelector = (state) => state.companies.current_page
export const getDivisionsPageCountSelector = (state) => state.companies.page_count